import { render } from "./title.vue?vue&type=template&id=97655588"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=97655588&lang=scss"
script.render = render

export default script